var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRemoveArtist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.056 1.026c4.916 0 6.972.542 8.955 1.603a10.782 10.782 0 0 1 4.486 4.485c1.06 1.983 1.603 4.04 1.603 8.956v5.905c0 4.917-.543 6.973-1.603 8.956a10.782 10.782 0 0 1-4.486 4.485c-1.983 1.06-4.039 1.603-8.955 1.603h-7.722c-4.917 0-6.973-.542-8.956-1.603a10.782 10.782 0 0 1-4.486-4.485c-1.06-1.983-1.603-4.04-1.603-8.956V16.07c0-4.917.543-6.973 1.603-8.956A10.782 10.782 0 0 1 7.378 2.63c1.983-1.06 4.039-1.603 8.956-1.603h7.722z",
    stroke: "#576078",
    strokeWidth: 1.352,
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Comfortaa-Medium, Comfortaa",
    fontSize: 25.2,
    fontWeight: 400,
    fill: "#FFF",
    transform: "translate(.613 .35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 26
  }, "-")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemoveArtist);
export default __webpack_public_path__ + "static/media/ic_remove_artist.500f663abffe2eb7bbdbcdab55e5f20c.svg";
export { ForwardRef as ReactComponent };